import Footer from "../../component/Footer";
import { useState } from "react";
import AgentNavbar from "../../component/AgentNavbar";
import { useNavigate } from "react-router-dom";
import RechargeNavbar from "./AgentComp/RechargeNavbar";

function RechargeCreditCardBills() {
  const [cardNumber, setCardNumber] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!/^[0-9]{16}$/.test(cardNumber)) {
      alert("Please enter a valid 16-digit credit card number.");
      return;
    }

    const searchParams = new URLSearchParams({ card: cardNumber }).toString();
    navigate(`/creditcard-payment?${searchParams}`);
  };

  return (
    <>
      <AgentNavbar />
      <div className="bgsearch1">
        <div className="container bg-2 midle">
          <RechargeNavbar />
          <h1 className="text-start agenth1 font3 txt6">Credit Card Bill Payment</h1>
          <hr />

          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="row g-3 text-start mb-3">
              {/* Credit Card Number Field */}
              <div className="col-md-6 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">Credit Card Number</label>
                <input
                  type="tel"
                  className="input2"
                  name="cardNumber"
                  placeholder="Enter 16-digit Credit Card Number"
                  value={cardNumber}
                  onChange={(e) => setCardNumber(e.target.value)}
                  required
                />
              </div>
            </div>

            <div>
              <button type="submit" className="submit-btn mt-3">
                Proceed to Pay Bill
              </button>
            </div>
          </form>

          <hr className="mt-4" />
          <p>Enter your credit card number to proceed with bill payment securely.</p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default RechargeCreditCardBills;
